import React, { useState, useEffect } from "react";
import Icon from "../../../assets/icons/Icon";
import Tooltip from "../../Tooltip/TooltipPopup";
import injectSheet from "react-jss";
import classNames from "classnames";
import Popup from "../../Popup/Popup";
import SamverkanspartItem from "./SamverkanspartItem";
import { connect } from "react-redux";
import { changeSelectedSmvp } from "../../../redux/actions/user";
import { OfficeIcon } from "../../../assets/icons/Icons";
import { GetData } from "../../../utils/axios";

const SamverkanspartNavItem = ({
  toggleSubmenu,
  visible,
  classes,
  userState,
  onlySamv,
  noIcon,
  text,
  datatype,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getMessages(false); //Retrieve messages each 10 seconds
    let getMessagesInterval = setInterval(() => {
      getMessages();
    }, 14000);
    return () => clearInterval(getMessagesInterval);
  }, [userState]);

  const handleOpenClose = () => {
    setIsOpen(!isOpen);
    if (toggleSubmenu) {
      toggleSubmenu();
    }
  };

  const justClose = (e) => {
    if (e.target.id !== "organisationer") {
      setIsOpen(false);
      if (toggleSubmenu) {
        toggleSubmenu();
      }
    }
  };

  const getMessages = async (createDynamicNotis = false) => {
    if (userState && userState.user && userState.user.id) {
      let url = "/notiser";
      if (createDynamicNotis) {
        url += "?createDynamicNotis=true";
      }
      const data = await GetData(url);
      if (data) return;
    }
  };

  return (
    <>
      <button
        id="organisationer"
        className={classNames(className, visible && classes.active)}
        style={{
          width: noIcon ? "140px" : "77px",
          textDecoration: userState.selectedSamverkanspart
            ? "underline"
            : "none",
        }}
        onClick={handleOpenClose}
        data-tooltip-content="Mina organisationer"
        data-tooltip-id="navbottom"
        data-place="bottom"
        data-tooltip-variant={datatype}
      >
        <div className={classes.buttonContainer}>
          {!noIcon && (
            <div className={classes.iconStyle}>
              <OfficeIcon size="18px" color="white" />
            </div>
          )}
          <div>{text ? text : "Organisationer"}</div>
        </div>
      </button>
      <Popup
        position="bottom"
        width="430px"
        overflowY="auto"
        height="269px"
        id="style-1"
        marginLeft={onlySamv ? "350px" : "300px"}
        contentStyle={classes.popupContent}
        arrowStyle={classes.popupArrow}
        className={classes.popup}
        isOpen={isOpen}
        handleClose={justClose}
        doNotHandleClickOutside={false}
      >
        {userState.samverkansparts.length > 0 ? (
          <>
            <div className={classes.samvInfo}>
              Lista på dina organisationer
              <div className={classes.popupheader}>
                <button onClick={handleOpenClose} title="Stäng">
                  <Icon type="clear" width="16px" />
                </button>
              </div>
            </div>
            <div style={{ marginTop: "46px" }} />
            {userState.samverkansparts.map(
              (smv, index) =>
                (smv.administrator || smv.lokalbokare) && (
                  <SamverkanspartItem
                    selectedSamverkanspart={userState.selectedSamverkanspart}
                    closePopup={handleOpenClose}
                    key={index}
                    samverkanspart={smv}
                  />
                )
            )}
          </>
        ) : (
          <div className={classes.noSamv}>
            Du har för tillfället inga organisationer!
          </div>
        )}
      </Popup>
      <Tooltip parent="message" />
    </>
  );
};

const styles = {
  noSamv: {
    fontWeight: "500",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  active: {
    color: "white!important",
    background: "#182d58!important",
  },
  samvInfo: {
    position: "fixed",
    borderBottom: "solid 1px #dbe0e8",
    fontWeight: "500",
    fontSize: "14px",
    textAlign: "left",
    padding: "16px 8px 14px 16px",
    display: "flex",
    width: "420px",
    height: "46px",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "4px",
    backgroundColor: "white",
  },
  /* popup: {
    marginLeft: "250px",
  }, */
  popupContent: {
    bottom: "0",
    top: "40px",
    right: "0",
    overflow: "auto",
    borderRadius: "15px",
    height: "fit-content",
  },
  popupArrow: {
    top: "unset",
    bottom: "-15px",
    right: "397px",
  },
  popupheader: {
    display: "none",
  },
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "5px",
    marginTop: "3px",
  },
  "@media (max-width: 1023px)": {
    popup: {
      marginLeft: "100px",
    },
    popupContent: {
      height: "unset",
    },
    iconStyle: { marginBottom: "0", marginTop: "0" },
    buttontext: { display: "none", fontSize: "11px" },
    samvInfo: {
      width: "calc(100% - 25px)",
      alignItems: "center",
      justifyContent: "space-between",
    },
    popupheader: {
      display: "block",
      textAlign: "right",
      "& button": {
        border: "0",
        background: "transparent",
        padding: "10px",
        color: "black",
      },
    },
  },
};

const mapStateToProps = (state) => {
  return {
    userState: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeSelectedSmvp: (value) => dispatch(changeSelectedSmvp(value)),
  };
};

SamverkanspartNavItem.displayName = "SamverkanspartNavItem";
const ConnectedSamverkanspart = connect(
  mapStateToProps,
  mapDispatchToProps
)(SamverkanspartNavItem);

export default injectSheet(styles)(ConnectedSamverkanspart);
